export default "__VITE_ASSET__c972b72f__"